/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_States_ProvincesInputs */

const en_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All States / Provinces`)
};

const es_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los estados / provincias`)
};

const fr_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les états / provinces`)
};

const de_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Bundesländer / Provinzen`)
};

const ja_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての州 / 都道府県`)
};

const zh_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有州/省`)
};

const ar_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع الولايات / المقاطعات`)
};

const id_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Negara Bagian / Provinsi`)
};

const it_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti gli Stati / Province`)
};

const ru_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все штаты / провинции`)
};

const pt_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os Estados / Províncias`)
};

const ko_all_states_provinces = /** @type {(inputs: All_States_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 주/도`)
};

/**
* | output |
* | --- |
* | "All States / Provinces" |
*
* @param {All_States_ProvincesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const all_states_provinces = /** @type {((inputs?: All_States_ProvincesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_States_ProvincesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_all_states_provinces(inputs)
	if (locale === "es") return es_all_states_provinces(inputs)
	if (locale === "fr") return fr_all_states_provinces(inputs)
	if (locale === "de") return de_all_states_provinces(inputs)
	if (locale === "ja") return ja_all_states_provinces(inputs)
	if (locale === "zh") return zh_all_states_provinces(inputs)
	if (locale === "ar") return ar_all_states_provinces(inputs)
	if (locale === "id") return id_all_states_provinces(inputs)
	if (locale === "it") return it_all_states_provinces(inputs)
	if (locale === "ru") return ru_all_states_provinces(inputs)
	if (locale === "pt") return pt_all_states_provinces(inputs)
	return ko_all_states_provinces(inputs)
});